import styled from "styled-components";

//Assets
import colors from "../../assets/css/colors"

export const Container = styled.div`
    display: flex;
    height: 100%;
`;

export const SideContainer = styled.div`
    width: 280px;
    height: 100%;
    max-height: 100%;
    border-right: 2px solid ${colors.sideBarBorder};    
`;

export const MainContainer = styled.div`
    display: flex;
    flex-grow: 2;
`;

export const FormSideContainer = styled.form`
    margin-top: 34px;
    margin-right: 37px;
`;

export const InputContainer = styled.div`
    width: 100%;
`;

export const Select = styled.select`
    width:100%;
    height: 31px;
    margin-top: 23px;
    margin-bottom: 23px;
    background: ${colors.white};
    color: ${colors.tertiary};
    border-radius: 7px;
    border: 1px solid rgba(194, 194, 194, 0.2);
    font-size: 0.8em;
    font-weight: 300;
    line-height: 1.45;
    outline: none;
    padding: 0.4em 1em 0.4em;
    -webkit-transition: 0.18s ease-out;
    -moz-transition: 0.18s ease-out;
    -o-transition: 0.18s ease-out;
    transition: 0.18s ease-out;

    -webkit-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    -moz-box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);
    box-shadow:  -4px 3px 19px -8px rgba(194, 194, 194, 0.726);

    &:hover {
        border: 1px solid rgba(255, 169, 89, 0.2);
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:focus {
        color: var(--gray);
        border: 1px solid ${colors.secondaryDark};
        -webkit-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        -moz-box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
        box-shadow: 0px 3px 33px -4px rgba(255, 202, 174, 0.815);
    }

    &:disabled {
        background-color: ${colors.grayLightest};
    }

    &::-webkit-input-placeholder {
        /* WebKit browsers */
        text-transform: none;
    }
    &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    &::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    &:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        text-transform: none;
    }
    &::placeholder {
        /* Recent browsers */
        text-transform: none;
    }
`;

export const RollableContainer = styled.div`
    height: 60.5%;
    overflow-y: scroll;
    margin-left: -37px;
`;